/* muss initiert werden sobald ein canvas vorhanden ist! */
const canvasesArr = document.getElementsByClassName("dynamicmeshcanvas");

/*
for(var i = 0; i < canvasesArr.length;i++){
  drawArea = canvasesArr[i].getContext("2d");
  let delay = 200, tid,
  rgb = opts.lineColor.match(/\d+/g);
  resizeReset();
  setup();
} */


const canvasBody = canvasesArr[0];



let resizeReset = canvasBody ? function() {
	w = canvasBody.width = window.innerWidth;
	h = canvasBody.height = canvasesArr[0].parentElement.offsetHeight;
} : '';

const opts = canvasBody ? { 
	particleColor: canvasBody.dataset.particlecolor,
	lineColor: canvasBody.dataset.linecolor,
    textColor: canvasBody.dataset.textcolor,
	particleAmount: parseInt(canvasBody.dataset.particleamount),
	defaultSpeed: parseFloat(canvasBody.dataset.defaultspeed),
	variantSpeed: parseFloat(canvasBody.dataset.variantspeed),
	defaultRadius: parseFloat(canvasBody.dataset.defaultradius),
	variantRadius: parseFloat(canvasBody.dataset.variantradius),
	linkRadius: parseFloat(canvasBody.dataset.linkradius),
	charOnNode: canvasBody.dataset.charonnode,
} : '';

//console.log(opts);

window.addEventListener("resize", function(){
	if(typeof deBouncerMesh === "function" ) { deBouncerMesh(); }
});

let deBouncerMesh = canvasBody ? function() {
    clearTimeout(tid);
    tid = setTimeout(function() {
        resizeReset();
    }, delay);
} : '';

let checkDistance = canvasBody ? function(x1, y1, x2, y2){ 
	return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
} : '';

let linkPoints = canvasBody ? function(point1, hubs){ 
	for (let i = 0; i < hubs.length; i++) {
		let distance = checkDistance(point1.x, point1.y, hubs[i].x, hubs[i].y);
		let opacity = 1 - distance / opts.linkRadius;
		if (opacity > 0) { 
			drawArea.lineWidth = 0.5;
			drawArea.strokeStyle = `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${opacity})`;
			drawArea.beginPath();
			drawArea.moveTo(point1.x, point1.y);
			drawArea.lineTo(hubs[i].x, hubs[i].y);
			drawArea.closePath();
			drawArea.stroke();
		}
	}
} : '';

Particle = canvasBody ? function(xPos, yPos){ 
	this.x = Math.random() * w; 
	this.y = Math.random() * h;
	this.speed = opts.defaultSpeed + Math.random() * opts.variantSpeed; 
	this.directionAngle = Math.floor(Math.random() * 360); 
	this.color = opts.particleColor;
    this.textColor = opts.textColor;
	this.radius = opts.defaultRadius + Math.random() * opts. variantRadius; 
	this.vector = {
		x: Math.cos(this.directionAngle) * this.speed,
		y: Math.sin(this.directionAngle) * this.speed
	};
	this.update = function(){ 
		this.border(); 
		this.x += this.vector.x; 
		this.y += this.vector.y; 
	};
	this.border = function(){ 
		if (this.x >= w || this.x <= 0) { 
			this.vector.x *= -1;
		}
		if (this.y >= h || this.y <= 0) {
			this.vector.y *= -1;
		}
		if (this.x > w) this.x = w;
		if (this.y > h) this.y = h;
		if (this.x < 0) this.x = 0;
		if (this.y < 0) this.y = 0;	
	};
	this.draw = function(){ 
		drawArea.beginPath();
		drawArea.arc(this.x, this.y, this.radius, 0, Math.PI*2);
		drawArea.closePath();
		drawArea.fillStyle = this.color;
		drawArea.fill();
        drawArea2.fillStyle = this.textColor; 
		drawArea2.font= 18 + 'px Verdana';       // font einstellungen müssen vor fill passieren!
        drawArea2.fillText("+",this.x-7,this.y+6);
		
	};
} : '';

function setup(){ 
	particles = [];
	resizeReset();
	for (let i = 0; i < opts.particleAmount; i++){
		particles.push( new Particle() );
	}
	window.requestAnimationFrame(loop);
}

function loop(){ 
	window.requestAnimationFrame(loop);
	drawArea.clearRect(0,0,w,h);
	for (let i = 0; i < particles.length; i++){
		particles[i].update();
		particles[i].draw();
	}
	for (let i = 0; i < particles.length; i++){
		linkPoints(particles[i], particles);
	}
}




drawArea = canvasBody ? canvasBody.getContext("2d") : '';
drawArea2 = canvasBody ? canvasBody.getContext("2d") : '';
let delay =  200, tid,
rgb = canvasBody ? opts.lineColor.match(/\d+/g) : '';
if(canvasBody){
	resizeReset();
setup();
}
